export default __webpack_public_path__ + "static/media/quiz_people.fc1eb01f.png";